let _this =  {

  /*-------------------------------------------------------------------------------
    # Cache dom and strings
  -------------------------------------------------------------------------------*/
  $dom: {
    descriptionBoxButton: $('.franli-module-single-product-hero-description-box-button'),
    descriptionBoxTable: $('.franli-module-single-product-hero-description-box-table'),

    content: document.querySelector('.content'),
    tables: document.querySelector('.tables'),
    tablesBtn: document.getElementById('tables-btn'),
    contentBtn: document.getElementById('content-btn'),
  },

  vars: {
  },

  /*-------------------------------------------------------------------------------
    # Initialize
  -------------------------------------------------------------------------------*/
  init: function () {

    const productInformations = document.querySelector('.franli-block-product-informations');

    if (productInformations) {
      this.$dom.contentBtn.classList.add('active');
      this.$dom.content.style.display = 'block';
      this.$dom.tablesBtn.addEventListener('click', this.showTables.bind(this));
      this.$dom.contentBtn.addEventListener('click', this.showContent.bind(this));
    }

    // Cache DOM elements
    const $items = $('.franli-module-single-product-hero-single-item');
    const $largeImage = $('.franli-module-single-product-hero__large-image--image');
    const $playButton = $('.large-play-button');

    // Set initial image and play button data-src
    $largeImage.attr('src', $items.first().find('.franli-module-single-product-hero-single-item--image').attr('src'));

    if ($items.first().find('.franli-module-single-product-hero-single-item--play-icon').attr('data-src')) {
      $playButton.find('img').attr('data-src', $items.first().find('.franli-module-single-product-hero-single-item--play-icon').attr('data-src'));
    } else {
      $playButton.addClass('disabled');
    }

    // Add click event listeners to items
    $items.on('click', function() {
      const $this = $(this);
      const hasPlayButton = $this.find('.franli-module-single-product-hero-single-item--play-icon').length > 0;

      // Get image src and play button data-src
      const imageSrc = $this.find('.franli-module-single-product-hero-single-item--image').attr('src');
      const playButtonDataSrc = hasPlayButton ? $this.find('.franli-module-single-product-hero-single-item--play-icon').attr('data-src') : '';

      // Set image src and play button data-src in the large image and play button elements
      $largeImage.attr('src', imageSrc);
      $playButton.find('img').attr('data-src', playButtonDataSrc);

      // Add disabled class to play button if item does not have play button
      $playButton.toggleClass('disabled', !hasPlayButton);
    });


    _this.$dom.descriptionBoxButton.on('click', function() {

    _this.$dom.descriptionBoxButton.toggleClass('active');
    _this.$dom.descriptionBoxButton.parent().toggleClass('show-table');

    });

    $(document).on('click', function(event) {
      if (!_this.$dom.descriptionBoxButton.is(event.target) && !_this.$dom.descriptionBoxTable.is(event.target) && !_this.$dom.descriptionBoxTable.has(event.target).length) {
        _this.$dom.descriptionBoxButton.parent().removeClass('show-table');
        _this.$dom.descriptionBoxButton.removeClass('active');
      }
    });

  },

  showTables: function () {
    this.$dom.content.style.display = 'none';
    this.$dom.tables.style.display = 'block';

    this.$dom.tablesBtn.classList.add('active');
    this.$dom.contentBtn.classList.remove('active');
  },

  showContent: function () {
    this.$dom.tables.style.display = 'none';
    this.$dom.content.style.display = 'block';

    this.$dom.contentBtn.classList.add('active');
    this.$dom.tablesBtn.classList.remove('active');
  }
};

export default _this;
